import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import Player from '@vimeo/player';
import getVideoId from 'get-video-id';

export default class Vimeo extends React.Component {

  static propTypes = {
    url: PropTypes.string,
    id: PropTypes.string,
    color: PropTypes.string,
    vimeoOptions: PropTypes.object,
  }

  static defaultProps = {
    color: 'ec4e47',
    vimeoOptions: {},
  }

  _initPlayer = () => {
    if (this.player) {
      this.player.unload();
    }
    if (this.video && this.video instanceof HTMLElement) {
      const { id } = this.props.id ? this.props : getVideoId(this.props.url);
      const { color, vimeoOptions } = this.props;
      this.player = new Player(this.video, {
        id,
        color,
        ...vimeoOptions,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.url !== this.props.url) || (prevProps.id && this.props.id && prevProps.id !== this.props.id)) {
      if (this.player) {
        const { id } = this.props.id ? this.props : getVideoId(this.props.url);
        this.player.loadVideo(id);
      }
    }
  }

  componentDidMount() {
    this._initPlayer();
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.unload();
    }
  }

  render() {
    return (
      <div className={`${this.props.className}`} ref={ref => this.video = ref} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Vimeo.js